import { render, staticRenderFns } from "./campaign-master-vins.vue?vue&type=template&id=716ce9fe"
import script from "./campaign-master-vins.vue?vue&type=script&lang=ts"
export * from "./campaign-master-vins.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports